<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md6
      >
        <div style="text-shadow: 3px 3px 4px #000;margin-left: -50px;font-family: Roboto; font-weight:900;font-size: 18em;letter-spacing: -35px;text-align:center;-webkit-text-stroke: 1px white;">
          403
        </div>
        <v-alert
          value="true"
          type="error"
        >
          You do not have the necessary permission to this resource.<br />
          <b>Permission:</b> {{$route.query.p}}
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Error404'
}
</script>
